// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChooseProf {
    margin-top: 50px;
    position: relative;
    display: inline-block;
}

.ChooseProf input {
    padding: 4px 8px;
    margin-left: 5px;
    margin-right: 10px;
    width: 220px;
}

.prof-dropdown {
    position: absolute;
    top: 100%;
    left: 5px;
    width: 220px;
    max-height: 200px;
    overflow-y: auto;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
    z-index: 100;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.prof-dropdown li {
    padding: 6px 10px;
    cursor: pointer;
}

.prof-dropdown li:hover {
    background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/choose_prof/choose_prof.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".ChooseProf {\n    margin-top: 50px;\n    position: relative;\n    display: inline-block;\n}\n\n.ChooseProf input {\n    padding: 4px 8px;\n    margin-left: 5px;\n    margin-right: 10px;\n    width: 220px;\n}\n\n.prof-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 5px;\n    width: 220px;\n    max-height: 200px;\n    overflow-y: auto;\n    background: white;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    z-index: 100;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n}\n\n.prof-dropdown li {\n    padding: 6px 10px;\n    cursor: pointer;\n}\n\n.prof-dropdown li:hover {\n    background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
